import { decorateSlides, rebuildCarousel } from './swiper-carousel';

const DATA_VALUE_SEPARATOR = ',';

function filterType(filter) {
  return filter.classList.contains('filter-dropdown') ? 'multiple' : 'single';
}

function filterOptions(filter) {
  if (filter.classList.contains('select-dropdown')) {
    return filter.querySelectorAll('ul.dropdown-menu li a');
  }
  if (filter.classList.contains('filter-dropdown')) {
    return filter.querySelectorAll(
      '.dropdown-menu .form-fields .form-check input'
    );
  }
  return [];
}

function parseValue(value) {
  return value.split(DATA_VALUE_SEPARATOR).map((i) => i.trim());
}

class Filter {
  constructor(filterContainer) {
    this.filterContainer = filterContainer;
    this.resultsContainer = null;
    this.filters = [];
    this.results = [];
    this.selectedFilters = {};
    this.init();
  }

  selectFilter(type, field, value) {
    if (type === 'single') {
      // if single selection:
      // - set value if not set or not the same
      // - clear value if already set and the same
      this.selectedFilters[field] =
        this.selectedFilters[field] !== value ? value : undefined;
    } else {
      // if multiple selection
      // - add value to set if not set
      // - remove value from set if already set
      this.selectedFilters[field] = this.selectedFilters[field] || [];
      const index = this.selectedFilters[field].indexOf(value);
      const list = [...this.selectedFilters[field]];
      if (index >= 0) {
        list.splice(index, 1);
      } else {
        list.push(value);
      }
      this.selectedFilters[field] = list;
    }
  }

  init() {
    // get DOM elements
    this.filters = Array.from(this.filterContainer.children);
    this.resultsContainer = document.getElementById(
      this.filterContainer.dataset.target
    );
    if (!this.resultsContainer || !this.resultsContainer.children) return;
    this.results = Array.from(this.resultsContainer.children);

    // for each filter
    this.filters.forEach((filter) => {
      // set selected filter state based on filter default value
      this.selectFilter(
        filterType(filter),
        filter.dataset.field,
        filter.dataset.value
      );
      // for each option in the filter, attach an event
      const options = filterOptions(filter);
      options.forEach((option) => {
        option.addEventListener('click', () => {
          // update selected filters based on option
          this.selectFilter(
            filterType(filter),
            filter.dataset.field,
            option.dataset.value || option.value
          );
          // filter results
          this.filterResults();
        });
      });
    });

    // filter results based on defaults
    this.filterResults();
  }

  filterResults() {
    const maybeCarousel = this.resultsContainer.parentElement;
    const isCarousel = !!maybeCarousel.classList.contains('swiper-container');
    // test each result
    this.results.forEach((result) => {
      // test all filters for each result
      const matches = this.filters.map((filter) => {
        if (filterType(filter) === 'single') {
          // single selection filter test
          return (
            !this.selectedFilters[filter.dataset.field] ||
            parseValue(result.dataset[filter.dataset.field]).indexOf(
              this.selectedFilters[filter.dataset.field]
            ) >= 0
          );
        }
        // multiple selection filter test
        return (
          !this.selectedFilters[filter.dataset.field] ||
          !this.selectedFilters[filter.dataset.field].length ||
          !!this.selectedFilters[filter.dataset.field]
            .map(
              (sf) =>
                parseValue(result.dataset[filter.dataset.field]).indexOf(sf) >=
                0
            )
            .filter(Boolean).length
        );
      });
      // if any tests fail, hide result
      // eslint-disable-next-line no-param-reassign
      result.style.display = matches.indexOf(false) >= 0 ? 'none' : 'block';
    });

    // if the results are to a carousel, rebuild the carousel
    if (isCarousel) {
      decorateSlides(maybeCarousel);
      rebuildCarousel(maybeCarousel);
    }
  }
}

export function initializeFilterHeader() {
  // active all filters (elements with data-filter="true" attribute)
  Array.from(document.querySelectorAll('[data-filter="true"]')).forEach(
    (filter) => new Filter(filter)
  );
}
